export const LIFE_BASE_GOVERNANCE_ROLES = ["admin", "salvia_operation_admin"] as const;

export const LIFE_BASE_GOVERNANCE_READONLY_MESSAGE =
  "A configuração de integrações e planos da Base de Vidas é restrita aos perfis administrativos globais da plataforma. Os demais perfis podem apenas consultar esse contexto.";

export function canManageLifeBaseGovernance(role?: string | null) {
  return Boolean(role && LIFE_BASE_GOVERNANCE_ROLES.includes(role as (typeof LIFE_BASE_GOVERNANCE_ROLES)[number]));
}
